import { textEditingUpdateTextMaker } from 'utils/actions';

export const FORUM_THREADS_FETCH = 'FORUM_THREADS_FETCH';
export const FORUM_THREADS_FETCH_SUCCESS = 'FORUM_THREADS_FETCH_SUCCESS';
export const FORUM_THREADS_FETCH_ERROR = 'FORUM_THREADS_FETCH_ERROR';
export const forumThreadsFetch = (page = 1, query, forumThreadsQueryString) => ({type: FORUM_THREADS_FETCH, page, query, forumThreadsQueryString});

export const FORUM_SIDEBAR_THREADS_FETCH = 'FORUM_SIDEBAR_THREADS_FETCH';
export const FORUM_SIDEBAR_THREADS_FETCH_SUCCESS = 'FORUM_SIDEBAR_THREADS_FETCH_SUCCESS';
export const FORUM_SIDEBAR_THREADS_FETCH_ERROR = 'FORUM_SIDEBAR_THREADS_FETCH_ERROR';
export const forumSidebarThreadsFetch = (page = 1, query, forumThreadsQueryString) => ({type: FORUM_SIDEBAR_THREADS_FETCH, page, query, forumThreadsQueryString});

export const FORUM_THREADS_RECEIVED = 'FORUM_THREADS_RECEIVED';
export const forumThreadsReceived = result => ({type: FORUM_THREADS_RECEIVED, result});

export const FORUM_THREADS_UPDATE_POSSIBLE_PAGE = 'FORUM_THREADS_UPDATE_POSSIBLE_PAGE';
export const forumThreadsUpdatePossiblePage = (possiblePage, forumThreadsQueryString) => ({type: FORUM_THREADS_UPDATE_POSSIBLE_PAGE, possiblePage, forumThreadsQueryString});

export const FORUM_THREAD_PROFILE_FETCH = 'FORUM_THREAD_PROFILE_FETCH';
export const FORUM_THREAD_PROFILE_FETCH_SUCCESS = 'FORUM_THREAD_PROFILE_FETCH_SUCCESS';
export const FORUM_THREAD_PROFILE_FETCH_ERROR = 'FORUM_THREAD_PROFILE_FETCH_ERROR';
export const forumThreadProfileFetch = forumThreadId => ({type: FORUM_THREAD_PROFILE_FETCH, forumThreadId});

export const FORUM_THREAD_FOLLOW = 'FORUM_THREAD_FOLLOW';
export const FORUM_THREAD_FOLLOW_SUCCESS = 'FORUM_THREAD_FOLLOW_SUCCESS';
export const FORUM_THREAD_FOLLOW_ERROR = 'FORUM_THREAD_FOLLOW_ERROR';
export const forumThreadFollow = (forumThreadId, followed) => ({type: FORUM_THREAD_FOLLOW, forumThreadId, followed});

export const FORUM_THREAD_UPDATE = 'FORUM_THREAD_UPDATE';
export const forumThreadUpdate = (forumThreadId, stateBeforeLocalUpdate, updates) => ({
  type: FORUM_THREAD_UPDATE,
  stateBeforeLocalUpdate,
  forumThreadId,
  updates
});

export const FORUM_THREAD_CREATE = 'FORUM_THREAD_CREATE';
export const FORUM_THREAD_CREATE_SUCCESS = 'FORUM_THREAD_CREATE_SUCCESS';
export const FORUM_THREAD_CREATE_ERROR = 'FORUM_THREAD_CREATE_ERROR';
export const forumThreadCreate = forumThreadProps => ({type: FORUM_THREAD_CREATE, forumThreadProps});

export const FORUM_EMOJIS_SHOW = 'FORUM_EMOJIS_SHOW';
export const forumEmojisShow = key => ({type: FORUM_EMOJIS_SHOW, key});

export const FORUM_EMOJIS_HIDE = 'FORUM_EMOJIS_HIDE';
export const forumEmojisHide = key => ({type: FORUM_EMOJIS_HIDE, key});

export const FORUM_CONTRIBUTE_EDITING_UPDATE_SUBJECT = 'FORUM_CONTRIBUTE_EDITING_UPDATE_SUBJECT';
export const forumContributeEditingUpdateSubject = subject => ({type: FORUM_CONTRIBUTE_EDITING_UPDATE_SUBJECT, subject});

export const FORUM_CONTRIBUTE_EDITING_UPDATE_TEXT = 'FORUM_CONTRIBUTE_EDITING_UPDATE_TEXT';
export const forumContributeEditingUpdateText = textEditingUpdateTextMaker(FORUM_CONTRIBUTE_EDITING_UPDATE_TEXT);

export const FORUM_CONTRIBUTE_EDITING_RESET = 'FORUM_CONTRIBUTE_EDITING_RESET';
export const forumContributeEditingReset = () => ({type: FORUM_CONTRIBUTE_EDITING_RESET});

export const FORUM_CONTRIBUTE_EDITING_EXPAND = 'FORUM_CONTRIBUTE_EDITING_EXPAND';
export const forumContributeEditingExpand = () => ({type: FORUM_CONTRIBUTE_EDITING_EXPAND});

export const FORUM_STATUS_UPDATE = 'FORUM_STATUS_UPDATE';
export const forumStatusUpdate = status => ({type: FORUM_STATUS_UPDATE, status});

export const FORUM_THREAD_WATCH = 'FORUM_THREAD_WATCH';
export const forumThreadWatch = forumThread => ({type: FORUM_THREAD_WATCH, forumThread});

export const FORUM_THREAD_UNWATCH = 'FORUM_THREAD_UNWATCH';
export const forumThreadUnwatch = forumThread => ({type: FORUM_THREAD_UNWATCH, forumThread});



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/actions.js
 **/